// extracted by mini-css-extract-plugin
export default {"searchBlock":"SearchBlock_searchBlock__HZKwN","content":"SearchBlock_content__MiLuF","title":"SearchBlock_title__EZFvY","bgImage":"SearchBlock_bgImage__O5HDb"};